import React from 'react'
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';

export default function Process() {
    const steps = [
        {
            id: 1,
            title: "Check Eligibility",
            desc: "Complete a simple digital application process designed for salaried professionals.",
            icon: <FileDownloadDoneIcon fontSize="large" />,
            bg: "bg-slate-900",
            numberBg: "bg-orange-500",
        },
        {
            id: 2,
            title: "Complete Verification",
            desc: "Upload the required KYC and verification details through a structured online process.",
            icon: <FileDownloadDoneIcon fontSize="large" />,
            bg: "bg-orange-500",
            numberBg: "bg-slate-900",
        },
        {
            id: 3,
            title: "Receive Funds",
            desc: "After approval and verification, eligible loan amounts are disbursed to the registered bank account.",
            icon: <FileDownloadDoneIcon fontSize="large" />,
            bg: "bg-orange-500",
            numberBg: "bg-slate-900",
        },
    ];
    return (

        <section className="w-full py-16 px-4 sm:px-6 lg:px-8 bg-white">
            <div className="max-w-7xl mx-auto">

                {/* Badge */}
               

                {/* Steps */}
                <div className="relative">

                    {/* Dotted Line (Desktop only) */}
                    <div className="hidden md:block absolute top-10 left-0 right-0 border-t-2 border-dashed border-orange-400"></div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

                        {steps.map((step) => (
                            <div
                                key={step.id}
                                className="flex flex-col items-center text-center relative group"
                            >

                                {/* Circle */}
                                <div className="relative">
                                    <div
                                        className={`w-20 h-20 sm:w-24 sm:h-24 rounded-full flex items-center justify-center text-white shadow-lg ${step.bg} group-hover:scale-105 transition`}
                                    >
                                        {step.icon}
                                    </div>

                                    {/* Step Number */}
                                    <div
                                        className={`absolute -top-2 -right-2 w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold ${step.numberBg}`}
                                    >
                                        {step.id}
                                    </div>
                                </div>

                                {/* Title */}
                                <h3 className="text-lg sm:text-xl font-semibold mt-4 mb-2">
                                    {step.title}
                                </h3>

                                {/* Description */}
                                <p className="text-gray-600 text-sm max-w-xs">
                                    {step.desc}
                                </p>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </section>

    )
}
